import { render, staticRenderFns } from "./OrganizationSummaryTable.vue?vue&type=template&id=5f4baffe&scoped=true"
import script from "./OrganizationSummaryTable.vue?vue&type=script&lang=js"
export * from "./OrganizationSummaryTable.vue?vue&type=script&lang=js"
import style0 from "./OrganizationSummaryTable.vue?vue&type=style&index=0&id=5f4baffe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4baffe",
  null
  
)

export default component.exports